package fr.frux.shared.data.repository

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.common.logging.Logger
import fr.frux.core.common.result.runCatchingCancellable
import fr.frux.core.network.api.PlacesApi
import fr.frux.core.network.error.mapFailureToAppError
import fr.frux.shared.data.mapper.toDomain
import fr.frux.shared.di.IoDispatcher
import fr.frux.shared.domain.model.Place
import fr.frux.shared.domain.repository.PlaceRepository
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.withContext

/** Passe-plat vers [PlacesApi] (#394) : ni cache ni état, le serveur fait les deux. */
@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class PlaceRepositoryImpl(
    private val placesApi: PlacesApi,
    @IoDispatcher private val dispatcher: CoroutineDispatcher,
) : PlaceRepository {
    override suspend fun searchPlaces(query: String): Result<List<Place>> =
        withContext(dispatcher) {
            runCatchingCancellable { placesApi.searchPlaces(query).places.map { it.toDomain() } }
                // Ni l'exception ni son message : celui d'une erreur Ktor porte l'URL, donc le texte
                // tape, et Logger.e part vers Sentry en release. L'echec est attendu et silencieux.
                .onFailure { Logger.d(TAG, "Recherche de lieux en echec (${it::class.simpleName})") }
                .mapFailureToAppError()
        }

    private companion object {
        const val TAG = "PlaceRepository"
    }
}
